/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-add-button.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../tx-float-button/tx-float-button.component.ngfactory';
import * as i3 from '../../../../../app/shared/component/tx-float-button/tx-float-button.component';
import * as i4 from '../../../../../app/shared/component/tx-add-button/tx-add-button.component';
const styles_TxAddButtonComponent:any[] = [i0.styles];
export const RenderType_TxAddButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxAddButtonComponent,data:{}});
export function View_TxAddButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'tx-float-button',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_TxFloatButtonComponent_0,
      i2.RenderType_TxFloatButtonComponent)),i1.ɵdid(1,114688,(null as any),0,i3.TxFloatButtonComponent,
      ([] as any[]),{iconName:[0,'iconName']},(null as any)),(_l()(),i1.ɵted(-1,0,
      ['\n    '])),i1.ɵncd(0,0),(_l()(),i1.ɵted(-1,0,['\n']))],(_ck,_v) => {
    const currVal_0:any = 'add';
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_TxAddButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-add-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxAddButtonComponent_0,
      RenderType_TxAddButtonComponent)),i1.ɵdid(1,114688,(null as any),0,i4.TxAddButtonComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxAddButtonComponentNgFactory:i1.ComponentFactory<i4.TxAddButtonComponent> = i1.ɵccf('tx-add-button',
    i4.TxAddButtonComponent,View_TxAddButtonComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtYWRkLWJ1dHRvbi90eC1hZGQtYnV0dG9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LWFkZC1idXR0b24vdHgtYWRkLWJ1dHRvbi5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LWFkZC1idXR0b24vdHgtYWRkLWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtYWRkLWJ1dHRvbi90eC1hZGQtYnV0dG9uLmNvbXBvbmVudC50cy5UeEFkZEJ1dHRvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx0eC1mbG9hdC1idXR0b24gW2ljb25OYW1lXT1cIidhZGQnXCI+XG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuPC90eC1mbG9hdC1idXR0b24+IiwiPHR4LWFkZC1idXR0b24+PC90eC1hZGQtYnV0dG9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7MENBQUEsVUFBQTtNQUFBLHVEQUFvQztNQUFBLG9CQUNoQyxNQUF5QjtJQURaO0lBQWpCLFdBQWlCLFNBQWpCOzs7O29CQ0FBO01BQUE7cUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-add-button/tx-add-button.component.ngfactory.ts